/**
 * Build-time configurations of urls used throughout the repository.
 */

let urls: {
  icons: string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    urls = {
      icons: "https://api-portalmotor.gyldendal.dk/fonts/gyldendalportaler",
    };
    break;

  case "staging":
    urls = {
      icons: "https://qa-api-portalmotor.gyldendal.dk/fonts/gyldendalportaler",
    };
    break;

  default:
    urls = {
      icons:
        "https://test-api-portalmotor.gyldendal.dk/fonts/gyldendalportaler",
    };
}

export { urls };
